if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.form.querySelector('[name=id]').disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-items');
        this.submitButton = this.querySelector('[type="submit"]');
        this.stayOnPageAfterAdd = this.hasAttribute('data-stay-on-page-after-add');
        this.goToCartAfterAdd = this.hasAttribute('data-go-to-cart-after-add');
        if (!this.stayOnPageAfterAdd && !this.goToCartAfterAdd) this.submitButton.setAttribute('aria-haspopup', 'dialog');
        this.stickyBarAtcButton = document.querySelector(`.normal-product-atc[data-product-id="${this.dataset.productId}"]`);
        if (this.stickyBarAtcButton) this.stickyBarAtcButton.addEventListener('click', this.onSubmitHandler.bind(this));
      }

      // REQ-B2B-5. Refuse to submit while a quantity rule is violated, so the buyer sees the reason
      // inline instead of a generic cart error after a round trip.
      hasQuantityRuleViolation() {
        const control = document.querySelector('quantity-input[data-quantity-invalid]');
        if (!control) return false;
        if (typeof control.validateQuantityRule === 'function' && control.validateQuantityRule()) return false;
        control.querySelector('input')?.focus();
        return true;
      }

      onSubmitHandler(evt) {
        if (this.hasQuantityRuleViolation()) {
          evt.preventDefault();
          return;
        }
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();
        this.handleSuccessMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading-overlay__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButton.querySelector('span').classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            }

            this.error = false;
            refreshCartIcon();

            if (this.stayOnPageAfterAdd) {
              this.dispatchEvent(
                new CustomEvent('b2b:product-form-added', {
                  bubbles: true,
                  detail: { productUrl: this.dataset.productUrl },
                }),
              );
              this.handleSuccessMessage(true);
              return;
            }

            if (this.goToCartAfterAdd) {
              window.location = window.routes.cart_url;
              return;
            }

            if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    this.cart.renderContents(response);
                  });
                },
                { once: true },
              );
              quickAddModal.hide(true);
            } else {
              this.cart.updateCart(this.submitButton);
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading-overlay__spinner').classList.add('hidden');
          });
      }

      handleErrorMessage(errorMessage = false) {
        this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      handleSuccessMessage(showMessage = false) {
        clearTimeout(this.successMessageTimer);

        for (const button of [this.submitButton, this.stickyBarAtcButton]) {
          if (!button) continue;
          const defaultLabel = button.querySelector('[data-product-form-default-label]');
          const successLabel = button.querySelector('[data-product-form-success-label]');
          if (!defaultLabel || !successLabel) continue;

          defaultLabel.toggleAttribute('hidden', showMessage);
          successLabel.toggleAttribute('hidden', !showMessage);
        }

        this.successMessage = this.successMessage || this.querySelector('[data-product-form-success]');
        if (this.successMessage) {
          this.successMessage.textContent = showMessage ? this.successMessage.dataset.successMessage : '';
        }

        if (showMessage) {
          this.successMessageTimer = setTimeout(() => this.handleSuccessMessage(), 3000);
        }
      }
    },
  );
}
